import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from './Navbar';
import RenewalsTab from './RenewalsTab';

export default function Renewals() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isUrgentFilter = searchParams.get('filter') === 'urgent';
  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/login');
  }, [navigate]);

  return (
    <div className="app-page">
      <Navbar back={{ to: '/dashboard', label: 'Back' }} />
      <main className="app-page-main" data-testid="renewals-page">
        <div className="app-page-header">
          <h1 className="app-page-title" data-testid="renewals-page-title">
            {isUrgentFilter ? 'Urgent Renewals' : 'Renewals'}
          </h1>
        </div>
        <RenewalsTab />
      </main>
    </div>
  );
}
